<template>
  <!--
    KAN-22：Paris 內視鏡分類提示字卡。比照既有 finding hint（FindingHintPopup）的
    浮層 + 置中卡片互動；差別是「醫師需要時間閱讀分類定義」，故不用 5 秒自動消失，
    改為點右上關閉鈕 / 點浮層背景關閉——關閉即完全移除浮層，不殘留遮罩、不鎖焦點（A3）。
  -->
  <div
    v-if="visible"
    class="paris-hint-background"
    data-test="paris-hint"
    @click.self="$emit('close')"
  >
    <div class="paris-hint">
      <button
        type="button"
        class="paris-hint__close"
        :aria-label="$t('paris_hint.close')"
        @click="$emit('close')"
      >
        ×
      </button>
      <h3 class="paris-hint__title">{{ $t("paris_hint.title") }}</h3>
      <ul class="paris-hint__list">
        <li
          v-for="entry in list"
          :key="entry.key"
          :class="['paris-hint__item', `paris-hint__item--lv${entry.level}`]"
        >
          {{ $t(`paris_hint.${entry.key}`) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ParisClassification } from "@/settings/parisClassification.js";

export default {
  name: "ParisHintPopup",
  props: {
    // 是否顯示提示字卡（由父層 morphology 欄位的提示鈕切換）
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: ParisClassification,
    };
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.paris-hint-background {
  width: 100%;
  height: 100vh;
  background: rgba(162, 162, 162, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 203;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.4s;
}

.paris-hint {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8%;
  width: 560px;
  max-width: 92vw;
  padding: 20px 24px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 3px 1px 10px #b0b0b0;
  text-align: left;

  &__close {
    position: absolute;
    top: 8px;
    right: 12px;
    border: none;
    background: transparent;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    color: #666;
  }

  &__title {
    text-align: center;
    margin-bottom: 12px;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__item {
    padding: 4px 0;
    &--lv0 {
      font-weight: 700;
      margin-top: 6px;
    }
    &--lv1 {
      padding-left: 20px;
      color: #333;
    }
  }
}
</style>
